import React from 'react';
import { MContentHeader } from '../../molecules/MContentHeader/index';
import { MContentHeaderAlignment } from '../../molecules/MContentHeader/MContentHeader.types';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { OMiniCardContainerProps } from './OMiniCardContainer.types';
import Styled from './OMiniCardContainer.styles';

const COMPONENT_NAME = 'o-mi-web-ui-kit-OMiniCardContainer';
const TESTID = 'mi-web-ui-kit-OMiniCardContainer';

export const OMiniCardContainer: React.FC<OMiniCardContainerProps> = ({
  desktopColumns = '3',
  mContentHeader,
  cqPath,
  className,
  ...props
}) => {
  const columns = parseInt(desktopColumns, 10) || 3;

  return (
    <Styled.Container className={className} data-component-name={COMPONENT_NAME} data-testid={TESTID}>
      {mContentHeader && (
        <Styled.HeaderWrapper>
          <MContentHeader
            alignment={mContentHeader.alignment || MContentHeaderAlignment.Left}
            mTextBlockSimple={mContentHeader.mTextBlockSimple}
            cta={mContentHeader.cta}
            mButton={mContentHeader.mButton}
            secondaryCta={mContentHeader.secondaryCta}
            mButton2={mContentHeader.mButton2}
          />
        </Styled.HeaderWrapper>
      )}

      <Styled.CardsGrid $desktopColumns={columns}>
        <EditableComponent
          pagePath={props.pagePath}
          itemPath={props.itemPath}
          cqPath={cqPath}
          config={{
            isEmpty: () => false,
            resourceType: 'mi-aem-common-spa/components/container',
          }}
        />
      </Styled.CardsGrid>
    </Styled.Container>
  );
};

export { OMiniCardContainer as default };
